import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year6/Summer/Shape/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Shape',
  field: 'Geometry',
  weeks: [1, 3],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Summer/Shape/1MeasureAndClassifyAngles" */ './1MeasureAndClassifyAngles'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(/* webpackChunkName: "Year6/Summer/Shape/2CalculateAngles" */ './2CalculateAngles')
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Summer/Shape/3VerticallyOppositeAngles" */ './3VerticallyOppositeAngles'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Summer/Shape/4AnglesInATriangle" */ './4AnglesInATriangle'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Summer/Shape/5AnglesInATriangleSpecialCases" */ './5AnglesInATriangleSpecialCases'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Summer/Shape/6AnglesInATriangleMissingAngles" */ './6AnglesInATriangleMissingAngles'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Summer/Shape/7AnglesInQuadrilaterals" */ './7AnglesInQuadrilaterals'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(/* webpackChunkName: "Year6/Summer/Shape/8AnglesInPolygons" */ './8AnglesInPolygons')
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () => import(/* webpackChunkName: "Year6/Summer/Shape/9Circles" */ './9Circles')
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Summer/Shape/10DrawShapesAccurately" */ './10DrawShapesAccurately'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(/* webpackChunkName: "Year6/Summer/Shape/11NetsOf3DShapes" */ './11NetsOf3DShapes')
    })
  ]
});
export default Block;
